import { useEffect, DependencyList } from 'react';

type UseScrollToOnInit = (
  canScroll: boolean,
  selector: string,
  deps?: DependencyList,
  delayMs?: number
) => void;

const useScrollToOnInit: UseScrollToOnInit = (
  canScroll,
  selector,
  deps,
  delayMs = 0
) => {
  useEffect(
    () => {
      if (!canScroll) return;
      const scroll = (): void => {
        document
          .querySelector(selector)
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      if (delayMs > 0) {
        // With delay: scroll after N ms; rAF not needed.
        const id = setTimeout(scroll, delayMs);
        return () => clearTimeout(id);
      }
      // No delay: rAF so scroll runs on next frame when layout is ready.
      requestAnimationFrame(scroll);
    },
    deps !== undefined ? [...deps, canScroll] : [canScroll]
  );
};

export default useScrollToOnInit;
